import client from "./_client";
import utils from "@/utils";

const endpoint = "/ip";

// GET REQUEST
export const getClientIP = async () => {
  try {
    const response = await client.get(endpoint);
    return response?.data?.ip || "Unknown";
  } catch (error) {
    return "Unknown";
  }
};
